module.exports = __webpack_public_path__ + "media/customizations/trilith/logo-new-6909f2646b086cfb14c7715f99049402.png";